import { isUserActionCommit } from '../../../lib/globals';
import { appStore } from '@/store';
import { SPINNER_TYPES } from '@/store/models/constants';
import { features } from '@/lib';

/**
 * @function setProgressiveSpinnerType
 * @description Sets the type of Progressive spinner
 * to use in the UI state
 */
const setProgressiveSpinnerType = (): void => {
  const { ui: uiActions } = appStore.getActions();

  const isPasskeyAvailable = appStore.getState().user.passkey.isAvailable;
  const { value: onboardOption } = appStore.getState().form.onboardOption;
  const isGuest = onboardOption === 'guest';
  const isWps = features.isActive('isWps');

  //note: feature check is inside SpinnerRender component
  if (isUserActionCommit()) {
    // completing a transaction - useraction=commit
    // NOTE: we are removing "thanks for using paypal" spinner for all
    // passkey eligible traffic even though passkey might not be
    // shown to user based on elmo response (during ramp)
    // REASON: we dont want to wait for passkey elmo results to
    // decide on type of spinner to show during approve call, as
    // passkey elmo is called in parallel with approve call
    // This decision was made with product team involved
    if (isPasskeyAvailable && !isWps && !isGuest) {
      uiActions.setSpinnerType(SPINNER_TYPES.empty);
    } else {
      uiActions.setSpinnerType(SPINNER_TYPES.thankYou);
    }
  } else {
    // sending back to merchant - useraction=continue
    uiActions.setSpinnerType(SPINNER_TYPES.almostDone);
  }
};

/**
 * @function markSpinnerOnRender
 * @description creates a performance marker to get duration
 * of progressive spinner
 * @param spinnerType adds the spinner type to detail property
 * of PerformanceMark
 */
const markSpinnerOnRender = ({
  spinnerType,
}: {
  spinnerType: string;
}): void => {
  window.performance?.mark('TransitionSpinnerRender', {
    detail: { spinnerType },
  });
};

export { setProgressiveSpinnerType, markSpinnerOnRender };
